import { onUnmounted, ref } from 'vue'
import { ElMessage } from 'element-plus'

export const BALANCE_TIP_COUNTDOWN = 4
export const BET_SUCCESS_COUNTDOWN = 3

export function useBetFeedback () {
  const balanceTipSheet = ref(false)
  const balanceTipCountdown = ref(BALANCE_TIP_COUNTDOWN)
  let balanceTipTimer = null

  const betSuccessSheet = ref(false)
  const betSuccessCountdown = ref(BET_SUCCESS_COUNTDOWN)
  let betSuccessTimer = null

  const clearBalanceTipTimer = () => {
    if (balanceTipTimer) {
      clearInterval(balanceTipTimer)
      balanceTipTimer = null
    }
  }

  const closeBalanceTip = () => {
    clearBalanceTipTimer()
    balanceTipSheet.value = false
  }

  const openBalanceTip = () => {
    clearBalanceTipTimer()
    balanceTipCountdown.value = BALANCE_TIP_COUNTDOWN
    balanceTipSheet.value = true
    balanceTipTimer = setInterval(() => {
      if (balanceTipCountdown.value <= 1) {
        closeBalanceTip()
        return
      }
      balanceTipCountdown.value -= 1
    }, 1000)
  }

  const clearBetSuccessTimer = () => {
    if (betSuccessTimer) {
      clearInterval(betSuccessTimer)
      betSuccessTimer = null
    }
  }

  const closeBetSuccessTip = () => {
    clearBetSuccessTimer()
    betSuccessSheet.value = false
  }

  const openBetSuccessTip = () => {
    clearBetSuccessTimer()
    betSuccessCountdown.value = BET_SUCCESS_COUNTDOWN
    betSuccessSheet.value = true
    betSuccessTimer = setInterval(() => {
      if (betSuccessCountdown.value <= 1) {
        closeBetSuccessTip()
        return
      }
      betSuccessCountdown.value -= 1
    }, 1000)
  }

  onUnmounted(() => {
    clearBalanceTipTimer()
    clearBetSuccessTimer()
  })

  /**
   * @param {() => Promise<{ success?: boolean, message?: string }>} betFn
   * @param {{ onSuccess?: () => void, onBalanceRefresh?: () => Promise<void> }} opts
   */
  const executeBet = async (betFn, { onSuccess, onBalanceRefresh } = {}) => {
    try {
      const res = await betFn()
      if (!res?.success) {
        const msg = String(res?.message || '')
        if (msg.includes('余额')) {
          openBalanceTip()
        } else {
          ElMessage.error(msg || '投注失败')
        }
        return false
      }
      if (onSuccess) onSuccess()
      if (onBalanceRefresh) await onBalanceRefresh()
      openBetSuccessTip()
      return true
    } catch (e) {
      const msg = e?.message || '投注失败'
      if (String(msg).includes('余额')) {
        openBalanceTip()
      } else {
        ElMessage.error(msg)
      }
      return false
    }
  }

  return {
    balanceTipSheet,
    balanceTipCountdown,
    closeBalanceTip,
    betSuccessSheet,
    betSuccessCountdown,
    closeBetSuccessTip,
    openBalanceTip,
    openBetSuccessTip,
    executeBet
  }
}
